import { useState } from "react";
import { AxiosError } from "axios";
import { convertPreferencesToSave, subjectMapper, SubjectValueProps } from "swing-components";

import {
  AlertError,
  isSameArrayContent,
  ModalSubProfileEdit,
  ModalSubProfileEditBody,
  ModalSubProfileEditFooter,
  ModalSubProfileEditHeader,
} from "~components";
import { Question } from "~onboarding/components";
import { QUESTION_SUBJECTS, UnsyncedSubAttribute } from "~onboarding/utils";
import { translate } from "~utils";

type ModalContentClassroomPreferencesSubjectsEditProps = {
  subjects?: SubjectValueProps;
  hasApiError?: AxiosError | null;
  onConfirm: (subjects: SubjectValueProps) => void;
  onDismiss: (data?: string | number, role?: string) => void;
  title: string;
};

export function ModalContentClassroomPreferencesSubjectsEdit(
  props: ModalContentClassroomPreferencesSubjectsEditProps,
) {
  const { subjects, hasApiError, onConfirm, onDismiss, title } = props;
  const [_subjects, _setSubjects] = useState<SubjectValueProps>(subjects ?? []);
  const _originalSubjects = subjects ?? [];
  const isSaveDisabled = _subjects.length <= 0 || isSameArrayContent(_originalSubjects, _subjects);

  function onChange({ value }: UnsyncedSubAttribute) {
    if (value) {
      const val = value as string;
      const convertedVals = convertPreferencesToSave(val, subjectMapper);
      _setSubjects(convertedVals);
    } else {
      _setSubjects([]);
    }
  }

  return (
    <ModalSubProfileEdit>
      <ModalSubProfileEditHeader onDismiss={onDismiss} title={title} />
      <ModalSubProfileEditBody>
        {!!hasApiError && <AlertError />}
        <div>
          <Question {...QUESTION_SUBJECTS} value={JSON.stringify(_subjects)} onChange={onChange} />
        </div>
      </ModalSubProfileEditBody>
      <ModalSubProfileEditFooter
        buttonPrimary={{
          isDisabled: isSaveDisabled,
          text: translate("LABEL_SAVE"),
          onClick: () => onConfirm(_subjects),
        }}
      />
    </ModalSubProfileEdit>
  );
}
